// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/abs/views/home/component/middle/index.less
// module id = 855
// module chunks = 42